import { useState } from 'react';
import { AlertPresentation } from './presentation';
import type { ActionProps, AlertType, TitleDescriptionProps } from './types';

type BaseProps = {
  /** 閉じるボタンを表示するか */
  showClose?: boolean;
  /** アラートの種類 */
  status: AlertType;
  /** 閉じるボタンが押された時のコールバック */
  onClose?: () => void;
};

type Props = BaseProps & TitleDescriptionProps & ActionProps;

export const Alert: React.FC<Props> = ({
  title,
  description,
  showClose,
  action,
  actionLink,
  onAction,
  status,
  onClose,
}) => {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    onClose?.();
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <AlertPresentation
      title={title}
      description={description}
      action={action}
      actionLink={actionLink}
      onAction={onAction}
      showClose={showClose}
      onClickClose={handleClose}
      status={status}
    />
  );
};
